import React, { forwardRef, useImperativeHandle, useState } from 'react';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { api } from '../../services';

const styles = {
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: 'absolute',
    right: '8px',
    top: '8px',
    color: 'black',
  },
};

const DialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography style={styles.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          style={styles.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const NOMES_ANDAR = ['Térreo', '1º Aéreo', '2º Aéreo'];

function getNomeAndar(andar) {
  return NOMES_ANDAR[andar - 1] || `Andar ${andar}`;
}

const DialogoEscolherAndarEndereco = forwardRef(
  ({ handleContinuar = () => {} }, ref) => {
    const [open, setOpen] = useState(false);
    const [carregando, setCarregando] = useState(false);
    const [disponiveis, setDisponiveis] = useState([]);
    const [andar, setAndar] = useState('');
    const [endereco, setEndereco] = useState(null);

    const handleCloseDialog = () => {
      setOpen(false);
      setAndar('');
      setEndereco(null);
    };

    useImperativeHandle(ref, () => ({
      async handleOpen() {
        setOpen(true);
        setCarregando(true);
        const response = await api.get(
          '/enderecos_exposicao_andares_produtos/disponiveis',
        );
        setDisponiveis(response.data);
        setCarregando(false);
      },
    }));

    const andaresComVaga = Array.from(
      new Set(disponiveis.map((item) => item.andar)),
    ).sort((a, b) => a - b);

    const opcoesEndereco = disponiveis.filter((item) => item.andar === andar);

    function handleChangeAndar(event) {
      setAndar(event.target.value);
      setEndereco(null);
    }

    function handleContinuarClick() {
      if (!andar || !endereco) return;
      handleContinuar({
        endereco_exposicao_produto_id: endereco.endereco_exposicao_produto_id,
        andar,
      });
      handleCloseDialog();
    }

    return (
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="xs"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" onClose={handleCloseDialog}>
          Registrar Entrada
        </DialogTitle>
        <MuiDialogContent>
          {carregando ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '24px',
              }}
            >
              <CircularProgress size={24} />
            </div>
          ) : (
            <>
              <Typography
                variant="body2"
                style={{ color: '#757575', marginBottom: '10px' }}
              >
                Escolha o andar e o endereço disponíveis para registrar a
                entrada:
              </Typography>
              <Select
                fullWidth
                variant="outlined"
                displayEmpty
                value={andar}
                onChange={handleChangeAndar}
              >
                <MenuItem value="" disabled>
                  Selecione o andar
                </MenuItem>
                {andaresComVaga.map((opcaoAndar) => (
                  <MenuItem key={opcaoAndar} value={opcaoAndar}>
                    {getNomeAndar(opcaoAndar)}
                  </MenuItem>
                ))}
              </Select>

              <Autocomplete
                value={endereco}
                onChange={(event, newValue) => setEndereco(newValue)}
                disabled={!andar}
                getOptionSelected={(option, value) =>
                  option.endereco_exposicao_produto_id ===
                  value.endereco_exposicao_produto_id
                }
                getOptionLabel={(option) => option.codigo || ''}
                options={opcoesEndereco}
                style={{ marginTop: '16px' }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Endereço"
                    fullWidth
                  />
                )}
              />
            </>
          )}
        </MuiDialogContent>
        <MuiDialogActions style={{ padding: '16px' }}>
          <Button onClick={handleCloseDialog}>Cancelar</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleContinuarClick}
            disabled={!andar || !endereco}
          >
            Continuar
          </Button>
        </MuiDialogActions>
      </Dialog>
    );
  },
);

export default DialogoEscolherAndarEndereco;
